<div class="w-full menu_con">
  <div class="container_width">
    <p-menubar [model]="items" styleClass="menu_top">
      <ng-template pTemplate="start" class="sm:hidden">
        <img src="../../../../assets/images/logo.svg" alt="" style="width: 116px;">
      </ng-template>
      <ng-template pTemplate="item" let-item let-root="root">
        <a pRipple
          class="flex align-items-center p-menuitem-link"
          [routerLink]="item.items ? null : item.routerLink"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="m-0">{{ item.label }}</span>
          <i *ngIf="item.items" [ngClass]="['pi', root ? 'pi-angle-down ml-2' : 'pi-angle-right ml-auto']"></i>
        </a>
      </ng-template>
      <ng-template pTemplate="end">
        <div class="flex align-items-center gap-2">
            <div class="card flex justify-content-center gap-2">
                <div style="position: relative; display: inline-block;">
                  <p-button icon="pi pi-comments" styleClass="notifications" (onClick)="onChatIconClick()" />
                  <ng-container *ngIf="(chatUnreadCount$ | async) as unreadCount">
                      <span *ngIf="unreadCount > 0" class="notification-badge">{{ unreadCount }}</span>
                  </ng-container>  
                </div>
                <div style="position: relative; display: inline-block;">
                  <p-button (onClick)="op.toggle($event)" icon="pi pi-bell" styleClass="notifications" />
                  <span *ngIf="unreadNotificationCount > 0" class="notification-badge">{{ unreadNotificationCount }}</span>
                </div>
                <p-overlayPanel #op [style]="{'width': '400px'}" (onShow)="markAllAsRead()">
                    <div class="flex flex-column gap-3 w-full max-w-25rem">
                        <b class="block w-full text-left font-bold text-xl" style="letter-spacing: -1px; color: #12263F;">Notifications</b>
                        <app-notification></app-notification>
                    </div>
                </p-overlayPanel>
            </div>
          <div class="card flex justify-content-center">
            <p-menu #menu [model]="userMenu" [popup]="true" appendTo="body" />
            <p-button (onClick)="menu.toggle($event)" styleClass="user_drop">
              <p-avatar size="large" [image]="user?.profileImageUrl || 'assets/images/default-profile.png'" shape="circle" />
            </p-button>
          </div>
        </div>
      </ng-template>
    </p-menubar>
  </div>
</div>
